var axios = require('axios')

// get categories list
axios.getCategoryList = function (params, success, callBackError) {
  this.get(process.env.prefix_menu + '/display-categories?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// get category detail
axios.getCategoryDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_menu + '/display-categories/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// create category
axios.createCategory = function (params, success, callBackError) {
  this.post(process.env.prefix_menu + '/display-categories', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// update category
axios.updateCategory = function (params, success, callBackError) {
  this.put(process.env.prefix_menu + '/display-categories/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

// upload category images
axios.uploadCategoryImages = function (params, configs, success, callBackError) {
  this.post(process.env.prefix_menu + '/display-categories/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// get categories by level
axios.getCategoryListByLevel = function (level, success, callBackError) {
  this.get(process.env.prefix_menu + '/display-categories?level=' + level)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.publishCategory = function (success, callBackError) {
  this.post(process.env.prefix_menu + '/display-categories/publish')
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getSingleTypes = function (success, callBackError) {
  this.get(process.env.prefix_menu + '/single-type-simple')
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

// upload single type images
axios.uploadSingleTypeImages = function (params, configs, success, callBackError) {
  this.post(process.env.prefix_menu + '/single-type/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// get single type detail
axios.getSingleTypeDetail = function (params, success, callBackError) {
  this.get(process.env.prefix_menu + '/single-type/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// create single type
axios.createSingleType = function (params, success, callBackError) {
  this.post(process.env.prefix_menu + '/single-type', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// update single type
axios.updateSingleType = function (params, success, callBackError) {
  this.put(process.env.prefix_menu + '/single-type', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

// update  status of single type
axios.updateStatusSingleType = function (params, success, callBackError) {
  this.put(process.env.prefix_menu + '/single-type-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.publishSingleType = function (success, callBackError) {
  this.post(process.env.prefix_menu + '/single-type/publish')
    .then(response => {
      success(response)
    }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Category.js